import React from "react";
import {UserOutlined} from "@ant-design/icons";
import {Avatar, Tooltip} from "antd";
import {Comment} from "@ant-design/compatible";
import {dateTimeFormat} from "../../lib/time";
import dayjs from "dayjs";
import PropTypes from "prop-types";

import "./SingleComment.less";

const lightGrey = '#f0f2f5';

function SingleComment({name, comment, timestamp, avatarSrc, greyBackground, children}) {
    const relativeTime = require('dayjs/plugin/relativeTime')
    dayjs.extend(relativeTime)

    const timezone = dayjs.tz()['$x']['$timezone'];
    const parsedTimestamp = dayjs.tz(timestamp, timezone);
    const timeFromNow  = parsedTimestamp.fromNow();
    const formattedTimestamp = parsedTimestamp.format(dateTimeFormat);

    // Comment out reply to action until we support it functionally
    // const actions = [
    //     <span key="comment-basic-reply-to">Reply to</span>,
    // ];

    return (
        <Comment
            // actions={actions}    Hide actions for MVP
            author={name}
            avatar={
                <Avatar
                    size={"large"}
                    icon={<UserOutlined/>}
                    src={avatarSrc}
                    alt={name}
                />
            }
            content={
                <div dangerouslySetInnerHTML={{__html: comment}}/>
            }
            datetime={
                <Tooltip title={formattedTimestamp}>
                    <span>{timeFromNow}</span>
                </Tooltip>
            }
            style={greyBackground ? {backgroundColor: lightGrey} : {}}
        >
            {children}
        </Comment>
    );
}

SingleComment.propTypes = {
    name: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
    avatarSrc: PropTypes.string,
};

SingleComment.defaultProps = {};

export default SingleComment;
